module.exports = __webpack_public_path__ + "static/img/rong3.3c13c88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rong3.jpg
// module id = fuwM
// module chunks = 52